import Chart from 'chart.js/auto';
import * as DomBuilder from "./dom-builder.js";

/**
 *
 * @version 2023-03-30
 * @author Patrik Harag
 */
export default class ComponentDatasetsChart {

    /** @type {HTMLElement} */
    panel = DomBuilder.div({ class: 'chart-panel' });

    createNode() {
        return this.panel;
    }

    /**
     *
     * @param datasets {Map<string,Dataset>}
     */
    refresh(datasets) {
        this.panel.replaceChildren();
        if (datasets.size > 1) {
            this.#buildPieChart(datasets);
        }
    }

    #buildPieChart(datasets) {
        let sizes = [];
        let labels = [];
        for (let [key, dataset] of datasets) {
            sizes.push(dataset.getTransactions().length);
            labels.push(dataset.getName());
        }

        const data = {
            labels: labels,
            datasets: [{
                label: 'Transactions',
                data: sizes,
                backgroundColor: [
                    'rgba(218,41,21,0.8)',
                    'rgba(218,74,21,0.8)',
                    'rgba(218,120,21,0.8)',
                    'rgba(255,204,0,0.8)',
                    'rgba(194,175,108,0.8)',
                    'rgba(108,108,108,0.8)',
                    'rgba(79,79,79,0.8)',
                    'rgba(58,58,58,0.8)',
                ],
                borderWidth: 1
            }]
        };

        const config = {
            type: 'bar',
            data: data,
            options: {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        };

        let canvas = DomBuilder.element('canvas');
        this.panel.append(canvas);
        const chart = new Chart(canvas, config);
    }
}